<template>
  <div class="document-links-dialog">
    <p class="subtitle-2">{{ $t('labels.document')  }}</p>

    <p class="document-links-dialog__description" v-html="$t('welcome.footer.document-dialog.title')" />

    <div class="document-links-dialog__links">
      <a v-for="link in links" :key="link.label" :href="link.href" target="_blank" class="document-links-dialog__link">
        <v-icon class="start-footer__link-icon" size="15">{{ link.icon }}</v-icon>
        <span>{{ link.label }}</span>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DocumentLinksDialog',

    computed: {
      links() {
        return [
          {
            href: 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2024/11/Mall-utvecklingsplan-2406.docx',
            icon: '$sl-write',
            label: this.$t('menu.development-plan'),
            target: '_blank'
          },
          {
            href: 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2024/11/Mall-tjanstgoringsintyg-2406.docx',
            icon: '$sl-trade-certificate',
            label: this.$t('menu.service-certificate'),
            target: '_blank'
          },
          {
            href: 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2024/05/Franvaroberakning_kvalificeringstid.xlsx',
            icon: '$sl-task-list-approve',
            label: this.$t('menu.absence-calculator-qualifying-time'),
            target: '_blank'
          },
          {
            href: 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2026/08/Mall-Ansokan-om-undantag-fran-aldersgrans-2608.docx',
            icon: '$sl-file',
            label: this.$t('menu.exemption-minor'),
            target: '_blank'
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.document-links-dialog {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 24px;

  &__links {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__link {
    width: fit-content;
    color: $color-text-dark !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 16px !important;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>